// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1rp6C","footer":"ModalCreateQualiphyProcedure_footer__2YSDi","additionData":"ModalCreateQualiphyProcedure_additionData__khua7"};